import React from 'react';
import { Clock, ShieldCheck, LogOut } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

const StaffApprovalPending = () => {
    const { logout, user } = useAuth();
    const navigate = useNavigate();

    const handleLogout = () => {
        logout();
        navigate('/');
    };

    return (
        <div className="min-h-screen bg-black flex flex-col items-center justify-center p-4 relative overflow-hidden">
            {/* Background Effects */}
            <div className="absolute inset-0 bg-[linear-gradient(to_right,#1e293b_1px,transparent_1px),linear-gradient(to_bottom,#1e293b_1px,transparent_1px)] bg-[size:4rem_4rem] [mask-image:radial-gradient(ellipse_60%_50%_at_50%_50%,#000_70%,transparent_100%)] opacity-20 pointer-events-none" />

            <div className="w-full max-w-md bg-gray-900/50 border border-gray-800 rounded-3xl p-8 backdrop-blur-xl shadow-2xl relative z-10 animate-in fade-in zoom-in duration-500">
                <div className="flex justify-center mb-8">
                    <div className="w-24 h-24 bg-yellow-500/10 rounded-full flex items-center justify-center border border-yellow-500/20 shadow-[0_0_30px_-5px_rgba(234,179,8,0.3)]">
                        <Clock className="w-12 h-12 text-yellow-500 animate-pulse" />
                    </div>
                </div>

                <div className="text-center space-y-4 mb-8">
                    <h1 className="text-2xl font-bold text-white">Cadastro em Análise</h1>
                    <div className="w-16 h-1 bg-yellow-500 mx-auto rounded-full" />
                    <p className="text-gray-300 leading-relaxed">
                        Olá, <strong className="text-white">{user?.name}</strong>. Recebemos seu cadastro com sucesso!
                    </p>
                    <p className="text-gray-400 text-sm">
                        Seus dados foram enviados para a direção e estão sob análise.
                        Você receberá o acesso ao painel assim que seu cadastro for aprovado.
                    </p>
                </div>

                <div className="bg-blue-500/5 border border-blue-500/10 rounded-xl p-4 flex items-start gap-3 mb-8">
                    <ShieldCheck className="w-5 h-5 text-blue-400 shrink-0 mt-0.5" />
                    <div className="text-left">
                        <p className="text-xs text-blue-200 font-medium">Próximos Passos</p>
                        <p className="text-xs text-blue-300/80 mt-1">
                            Informe à direção que você finalizou o preenchimento para agilizar sua liberação.
                        </p>
                    </div>
                </div>

                <Button
                    onClick={handleLogout}
                    className="w-full bg-gray-800 hover:bg-gray-700 text-white border border-gray-700"
                    variant="outline"
                >
                    <LogOut className="mr-2 w-4 h-4" />
                    Sair e Aguardar
                </Button>
            </div>

            <div className="absolute bottom-8 text-center">
                <p className="text-xs text-gray-600 font-medium tracking-widest uppercase">Grupo Capital</p>
            </div>
        </div>
    );
};

export default StaffApprovalPending;
